import { Flex } from 'core/components';
import React, { PropsWithChildren } from 'react';

function PlanCardLeftFlex({ children }: PropsWithChildren<object>): JSX.Element {
  return <Flex flex="1 1 auto">{children}</Flex>;
}

export default PlanCardLeftFlex;
